import { InlineError } from "@/modules/form-field/errors";
import { useField$Custom } from "@/modules/form-field/hooks/useField$Custom";
import {
  fromLovelaceAmount,
  toLovelaceAmount,
} from "@/modules/form-field/utils/conversions";

type Value = number;
type Draft = string;
type Params = { initialValue: Value | undefined; min: number; max: number };

function normalizeDraft(draft: Draft) {
  return draft.replace(/[\s,]/g, "");
}

function validateDraft(draft: Draft, params: Params): Value {
  const value = toLovelaceAmount(normalizeDraft(draft));
  InlineError.assert$PunishAfterEditing(
    value >= params.min, //
    `Cannot be less than ${params.min / 1000000} ADA`
  );
  InlineError.assert$PunishAfterEditing(
    value <= params.max,
    `Cannot be more than ${params.max / 1000000} ADA`
  );
  return value;
}

export const useFieldListingPrice = useField$Custom.withConfig<
  Value,
  Draft,
  Params
>({
  getInitialDraft: (params) =>
    params.initialValue != null ? fromLovelaceAmount(params.initialValue) : "",
  draftToValue: toLovelaceAmount,
  valueToDraft: fromLovelaceAmount,
  normalizeDraft,
  validateDraft,
});
